import React from "react";

export default function PushConsentModal({ onAllow, onDeny, onLater, disabled = false }) {
  return (
    <div className="modal-overlay" onClick={onLater}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3>Benachrichtigungen aktivieren?</h3>

        <p style={{ marginTop: 10 }}>
          So verpasst du keine neuen Nachrichten.
        </p>

        <div className="modal-buttons">
          <button
            className="green-button"
            onClick={onAllow}
            disabled={disabled}
          >
            Ja, aktivieren
          </button>

          <button
            className="red-button"
            onClick={onDeny}
            disabled={disabled}
          >
            Nein
          </button>

          <button
            className="green-button"
            onClick={onLater}
            disabled={disabled}
          >
            Vielleicht später
          </button>
        </div>
      </div>
    </div>
  );
}